import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import s from './ProjectsList.module.css';
import testIcon from '../../assets/icons/testIconProject.png';
import { Project, News } from '../../types/api.types';
import { projectsApi } from '../../api/projects';
import { newsApi } from '../../api/news';

export const ProjectsList: React.FC = () => {
    const navigate = useNavigate();
    const [projects, setProjects] = useState<Project[]>([]);
    const [news, setNews] = useState<News[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        try {
            setLoading(true);
            const [projectsData, newsData] = await Promise.all([
                projectsApi.getAll(),
                newsApi.getLatest()
            ]);
            console.log('📦 Проекты с бэка:', projectsData);
            console.log('📦 Новости с бэка:', newsData);
            setProjects(projectsData);
            setNews(newsData);
        } catch (error) {
            console.error('Ошибка загрузки:', error);
        } finally {
            setLoading(false);
        }
    };

    const columnCounts = [2, 3, 2];
    const sortedProjects = [...projects].sort((a, b) => {
        if (a.columnNumber !== b.columnNumber) {
            return a.columnNumber - b.columnNumber;
        }
        return a.sortOrder - b.sortOrder;
    });

    const columns = columnCounts.map((count, colIndex) => {
        const columnNumber = colIndex + 1;
        const columnProjects = sortedProjects.filter(p => p.columnNumber === columnNumber);

        return (
            <div key={colIndex} className={s.column}>
                {columnProjects.map(project => (
                    <div key={project.id} className={s.projectCard}
                         onClick={() => navigate('/project/' + project.id)}
                    >
                        <h3 className={s.projectTitle}>{project.title}</h3>
                        {project.iconUrl && (
                            <img src={project.iconUrl} alt={project.title} className={s.projectImage} />
                        )}
                    </div>
                ))}
            </div>
        );
    });

    const stripHtml = (html: string) => {
        if (!html) return '';
        const div = document.createElement('div');
        div.innerHTML = html;
        return div.textContent || div.innerText || '';
    };

    const extractFirstImageFromHtml = (html: string): string | null => {
        if (!html) return null;
        const imgMatch = html.match(/<img[^>]+src="([^">]+)"/);
        return imgMatch ? imgMatch[1] : null;
    };

    const handleNewsClick = (newsId: number, e: React.MouseEvent) => {
        e.stopPropagation();
        navigate('/news/' + newsId);
    };

    if (loading) {
        return <div className={s.loading}>Загрузка...</div>;
    }

    return (
        <div className={s.projectsList}>
            {columns[0]}
            {columns[1]}
            {columns[2]}
            <div className={s.newsColumn}>
                <h3
                    className={s.newsTitle}
                >
                    Новости
                </h3>
                {news.slice(0, 2).map(item => {
                    const htmlContent = item.content?.html || '';
                    const imageSrc = extractFirstImageFromHtml(htmlContent) || testIcon;
                    const cleanDescription = stripHtml(htmlContent);
                    const shortDescription = cleanDescription.length > 100
                        ? cleanDescription.substring(0, 100) + '...'
                        : cleanDescription;

                    return (
                        <div
                            key={item.id}
                            className={s.newsItem}
                            onClick={(e) => handleNewsClick(item.id, e)}
                        >
                            <img src={imageSrc} alt={item.title} className={s.newsImage} />
                            <div className={s.newsContent}>
                                <div className={s.newsText}>{item.title}</div>
                                <div className={s.newsDescription}>{item.displayDescription || shortDescription}</div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};